import {useState} from "react";
import Step1SlotGuide from "./steps/Step1SlotGuide";
import Step2CreateForm from "./steps/Step2CreateForm";

function SelfCustomAvatarDashboardModal({closeModal}) {
  const [step, setStep] = useState(1)
  const [formData, setFormData] = useState({name: '', file: null})

  const next = () => setStep((prev) => prev + 1)
  const prev = () => setStep((prev) => prev - 1)

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center p-4 sm:p-8 overflow-auto">
      {step === 1 && <Step1SlotGuide next={next} close={closeModal}/>}
      {step === 2 && (
        <Step2CreateForm
          formData={formData}
          setFormData={setFormData}
          prev={prev}
          close={closeModal}
        />
      )}
    </div>
  )
}

export default SelfCustomAvatarDashboardModal
